import { Vector } from "@animech/axiom-format";
import { getSubpropertyNames } from "@animech/axiom-utility";
import { Property } from "src/common";

export type VectorPropertyName = "position" | "rotation" | "scale";

export type PropertyDataWithVectors<
	TSubpropertyName extends VectorPropertyName,
> = {
	[K in TSubpropertyName]: Vector;
};

export type PropertyWithVectors<TSubpropertyName extends VectorPropertyName> = [
	TSubpropertyName,
] extends [VectorPropertyName]
	? Property<PropertyDataWithVectors<TSubpropertyName>>
	: never;

export function hasVectorProperties<T extends VectorPropertyName>(
	property: Property,
	...vectorPropertyNames: T[]
): property is PropertyWithVectors<T> {
	const subpropertyNames = getSubpropertyNames(property) as string[];

	// TODO: This currently just assumes that subproperties with these
	// names are of Vector type. If possible, it would be better if
	// we could actually assert this fact somehow.

	return vectorPropertyNames.every((vectorPropertyName) =>
		subpropertyNames.includes(vectorPropertyName),
	);
}
